import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteInitiativesSyncJiraRequest = {
	customerId: number;
	initiativeId: number;
	issueKey: string;
};

export const deleteInitiativesUnsyncJira = createDeleteEndpoint<DeleteInitiativesSyncJiraRequest>(
	({ initiativeId }) => `/api/v3/initiatives/${initiativeId}/unsync-jira`,
	{
		requestTransform: ({ initiativeId, ...rest }) => rest
	}
);
